(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const smdSeenCards = new WeakSet();
  function smdShuffleCollections() {
    document.querySelectorAll('results-list[data-smd-random="true"]').forEach((root) => {
      if (new URLSearchParams(location.search).has('sort_by')) return;
      const cards = [...root.querySelectorAll('li.product-grid__item[data-product-id]')];
      if (!cards.length || cards.every((card) => smdSeenCards.has(card))) return;
      const groups = new Map();
      cards.forEach((card) => {
        smdSeenCards.add(card);
        const key = card.dataset.page || '1';
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(card);
      });
      groups.forEach((items) => {
        const parent = items[0].parentElement;
        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [items[i], items[j]] = [items[j], items[i]];
        }
        items.forEach((card) => parent.appendChild(card));
      });
    });
  }
  let smdShuffleQueued = false;
  const smdScheduleShuffle = () => {
    if (smdShuffleQueued) return;
    smdShuffleQueued = true;
    queueMicrotask(() => {
      smdShuffleQueued = false;
      smdShuffleCollections();
    });
  };
  const smdStartShuffle = () => {
    smdShuffleCollections();
    const main = document.querySelector('main');
    if (main) new MutationObserver(smdScheduleShuffle).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', smdStartShuffle, { once: true });
  } else {
    smdStartShuffle();
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smd-collection-heading"]) return;
  try {
    
if (!customElements.get('smd-collection-description')) {
  customElements.define('smd-collection-description', class extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.smd-collection-description');
      this.button = this.querySelector('button');
      this.button.onclick = () => {
        const expanded = this.button.getAttribute('aria-expanded') !== 'true';
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        this.text.classList.toggle('smd-is-collapsed', !expanded);
      };
      this.measure = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return;
        this.text.classList.add('smd-is-collapsed');
        this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
      };
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.text);
      this.measure();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smd-cyber-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smd-cyber-countdown')) {
  customElements.define('smd-cyber-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.tick();
      if (!this.hidden) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
    tick() {
      const remaining = Math.ceil((this.end - Date.now()) / 1000);
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return;
      }
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60
      };
      for (const [unit, value] of Object.entries(values)) {
        this.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0');
      }
      this.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smd-lab-c3-usb"]) return;
  try {
    
document.addEventListener('click',function(event){
const button=event.target.closest('[data-c3-download]');
if(!button)return;
const root=button.closest('.smd-c3');
const code=root.querySelector('[data-c3-code]');
if(!code)return;
const url=URL.createObjectURL(new Blob([code.textContent],{type:'text/plain;charset=utf-8'}));
const a=document.createElement('a');
a.href=url;a.download='smdbyte_c3_usb_test.ino';
document.body.appendChild(a);a.click();a.remove();
setTimeout(function(){URL.revokeObjectURL(url)},10000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smdbyte-component-search"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const compact = value => normalize(value).replace(/[^a-z0-9]/g, '');
  const distance = (a, b) => {
    let row = Array.from({length: b.length + 1}, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
      const next = [i];
      for (let j = 1; j <= b.length; j++) next[j] = Math.min(next[j - 1] + 1, row[j] + 1, row[j - 1] + (a[i - 1] !== b[j - 1]));
      row = next;
    }
    return row[b.length];
  };
  const groups = [['zumbador','buzzer'],['condensador','capacitor'],['pulsador','boton'],['pantalla','display','oled'],['temperatura','humedad','dht11'],['regulador','ldo','ams1117']];
  const init = scope => scope.querySelectorAll('[data-component-finder]').forEach(el => {
    if (el.dataset.ready) return;
    el.dataset.ready = 'true';
    const copy = JSON.parse(el.querySelector('[data-copy]').textContent);
    const input = el.querySelector('[name=q]'), status = el.querySelector('[data-status]'), results = el.querySelector('[data-results]');
    let catalogPromise, sequence = 0, timer;
    const catalog = () => catalogPromise ||= (async () => {
      const products = [], seen = new Set();
      for (let page = 1; ; page++) {
        const response = await fetch(`${el.dataset.root}products.json?limit=250&page=${page}`, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('catalog');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw new Error('catalog');
        let added = 0;
        for (const p of data.products) if (!seen.has(p.id)) {
          seen.add(p.id); added++;
          p.normalTitle = normalize(p.title);
          p.words = normalize([p.title,p.product_type,...(p.tags || []),...(p.variants || []).map(v=>v.sku || '')].join(' ')).split(/\s+/);
          products.push(p);
        }
        if (data.products.length < 250) return products;
        if (!added || page >= 40) throw new Error('incomplete');
      }
    })().catch(error => {catalogPromise = null; throw error;});
    const score = (p, query) => {
      const terms = normalize(query).split(/\s+/).filter(Boolean);
      let total = 0;
      for (const term of terms) {
        const key = compact(term);
        const aliases = groups.find(group=>group.includes(term)) || [];
        let best = 0;
        for (const word of p.words) {
          const candidate = compact(word);
          if (candidate === key) best = Math.max(best,100);
          else if (key.length >= 2 && candidate.includes(key)) best = Math.max(best,75);
          else if (aliases.includes(word)) best = Math.max(best,45);
          else if (key.length >= 4 && Math.abs(candidate.length-key.length)<=1 && distance(candidate,key)<=1) best = Math.max(best,35);
        }
        if (!best) return 0;
        total += best;
      }
      return total + (p.normalTitle === normalize(query) ? 200 : 0);
    };
    const run = async () => {
      const id = ++sequence, query = input.value.trim().slice(0,100);
      results.replaceChildren();
      if (query.length < 2) {status.textContent = copy.minimum; return;}
      status.textContent = copy.loading;
      try {
        const products = await catalog();
        if (id !== sequence) return;
        const matches = products.map(p=>({p,score:score(p,query)})).filter(x=>x.score>0).sort((a,b)=>b.score-a.score || Number(b.p.variants.some(v=>v.available))-Number(a.p.variants.some(v=>v.available)) || a.p.title.localeCompare(b.p.title)).slice(0,24);
        status.textContent = matches.length ? copy.matches : copy.empty;
        for (const {p} of matches) {
          const link = document.createElement('a');link.href = `${el.dataset.root}products/${encodeURIComponent(p.handle)}`;
          const src = p.images?.[0]?.src;
          if (src && src.startsWith('https://')) {const img = document.createElement('img');img.src=src;img.alt=p.title;img.loading='lazy';link.append(img);}
          const title = document.createElement('span');title.textContent=p.title;link.append(title);
          const variants = p.variants || [], prices=variants.map(v=>Number(v.price)).filter(Number.isFinite);
          if (prices.length) {const price=document.createElement('strong');price.textContent=(new Set(prices).size>1 ? copy.from+' ' : '')+new Intl.NumberFormat('es-CL',{style:'currency',currency:el.dataset.currency || 'CLP'}).format(Math.min(...prices));link.append(price);}
          const stock=document.createElement('small');stock.textContent=variants.some(v=>v.available) ? copy.available : copy.soldout;link.append(stock);results.append(link);
        }
      } catch (error) {if(id===sequence) status.textContent=copy.error;}
    };
    input.addEventListener('input',()=>{sequence++;clearTimeout(timer);timer=setTimeout(run,250);});
    el.querySelector('form').addEventListener('submit',event=>{event.preventDefault();clearTimeout(timer);run();});
  });
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smdbyte-kits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smd-kit-carousel')) {
  customElements.define('smd-kit-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.updateButtons(), {...options,passive:true});
      this.observer = new ResizeObserver(() => this.updateButtons());
      this.observer.observe(this.track);
      this.updateButtons();
    }
    updateButtons() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
